import "./App.css";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import WelcomePage from "./pages/Welcome/WelcomePage";
import Header from "./components/Header/Header";
import HomePage from "./pages/UserPages/Home/HomePage";
import AdminHome from "./pages/AdminPages/Home/AdminHome";
import { Routes, Route } from "react-router";
import { useEffect, useContext } from "react";
import { AppContext } from "./context/AppContext";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import CoursePage from "./pages/UserPages/CoursePage/CoursePage";
import StudentsPage from "./pages/AdminPages/StudentsPage/StudentsPage";
import CreateCourse from "./pages/AdminPages/CreateCourse/CreateCourse";
import EditCourse from "./pages/AdminPages/EditCourse/EditCourse";
import EditSection from "./pages/AdminPages/EditSection/EditSection";
import CreateLesson from "./pages/AdminPages/CreateLesson/CreateLesson";
import EditLesson from "./pages/AdminPages/EditLesson/EditLesson";
import AddCourseUser from "./pages/AdminPages/AddCourseUser/AddCourseUser";
import WatchLesson from "./pages/UserPages/WatchLesson/WatchLesson";
import CourseTasks from "./pages/AdminPages/CourseTasks/CourseTasks";
import TaskPage from "./pages/AdminPages/TaskPage/TaskPage";
import CourseStatistic from "./pages/AdminPages/StudentsPage/CourseStatistic";
function App() {
  const { token, setToken, userId, setUserId } = useContext(AppContext);
  useEffect(() => {
    const localToken = localStorage.getItem("token");
    setToken(localToken);
    const localId = localStorage.getItem("id");
    setUserId(localId);
  }, [token, setToken]);
  return (
    <div className="App">
      <Header user={userId} />
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin/:id" element={<AdminHome />} />
        <Route path="/home/user/:id" element={<HomePage />} />
        <Route
          path="/create-course"
          element={
            <ProtectedRoute>
              <CreateCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course-students/:courseId"
          element={
            <ProtectedRoute>
              <StudentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course/statistics"
          element={
            <ProtectedRoute>
              <CourseStatistic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:id"
          element={
            <ProtectedRoute>
              <EditCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:id/sections"
          element={
            <ProtectedRoute>
              <EditSection />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:id/sections/:sectionId/lessons"
          element={
            <ProtectedRoute>
              <CreateLesson />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:id/sections/:sectionId/lessons/:lessonId"
          element={
            <ProtectedRoute>
              <EditLesson />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/:userId/course/:id"
          element={
            <ProtectedRoute>
              <CoursePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course/:courseId/section/:sectionId/lesson/:lessonId"
          element={
            <ProtectedRoute>
              <WatchLesson />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/:id/add-user"
          element={
            <ProtectedRoute>
              <AddCourseUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/tasks"
          element={
            <ProtectedRoute>
              <CourseTasks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course/:id/section/:sectionId/lesson/:lessonId/tasks"
          element={
            <ProtectedRoute>
              <TaskPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
